import { NgModule } from '@angular/core';
import { SharedModule } from '@api-ui-app/src/app/shared/shared.module';
import { HeaderCreateMenuStatelessComponent } from '@api-ui-app/src/app/header-create-menu/components/header-create-menu-stateless/header-create-menu-stateless.component';
import { HeaderCreateMenuComponent } from '@api-ui-app/src/app/header-create-menu/containers/header-create-menu/header-create-menu.component';
import { HeaderCreateMenuFacade } from '@api-ui-app/src/app/header-create-menu/header-create-menu.facade';
import { ECommerceStoreSelectionModalModule } from '@api-ui-app/src/app/e-commerce-store-selection-modal/e-commerce-store-selection-modal.module';
import { HeaderCreateMenuEffects } from './+state/header-create-menu.effects';

import { headerCreateMenuFeatureKey, headerCreateMenuReducerToken, reducer } from './+state/header-create-menu.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductAddModule } from '@api-ui-app/src/app/product/product-add/product-add.module';
import { ChooseTemplateModalContainerModule } from '@api-ui-app/src/app/choose-template-modal/choose-template-modal-container.module';
import { LogEventDirective } from '@gelato-api-ui/ui-kit/src/lib/analytics/log-event.directive';

@NgModule({
  declarations: [HeaderCreateMenuStatelessComponent, HeaderCreateMenuComponent],
  exports: [HeaderCreateMenuComponent],
  imports: [
    SharedModule,
    ECommerceStoreSelectionModalModule,
    ProductAddModule,
    ChooseTemplateModalContainerModule,
    StoreModule.forFeature(headerCreateMenuFeatureKey, headerCreateMenuReducerToken),
    EffectsModule.forFeature([HeaderCreateMenuEffects]),
    LogEventDirective,
  ],
  providers: [
    {
      provide: headerCreateMenuReducerToken,
      useValue: reducer,
    },
    HeaderCreateMenuFacade,
  ],
})
export class HeaderCreateMenuModule {}
